// extracted by mini-css-extract-plugin
module.exports = {"progressWrapper":"Progress_progressWrapper__1n3e3","progress":"Progress_progress__1zo-D"};